import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingBar from "../../components/LoadingBar/LoadingBar.js";
import ModalCadastro from "../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../components/ModalUsuario/ModalUsuario.tsx";
import NewIcon from "../../components/NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../../components/SelectEmbarqueV2/SelectEmbarqueV2";
import TabelaV2 from "../../components/TabelaV2/TabelaV2";
import ToastErro from "../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController";
import TabelaRedux from "../../contexts/Tabela";
import MotionContainer from "../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../core/components/MotionSemAutorizacao.tsx";
import Layout from "../../core/layout/Layout.tsx";
import { getValorEmbarqueDependencias } from "../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraValorEmbarque,
	deleteValorEmbarquePorId,
	editaValorEmbarquePorId,
	getValorEmbarque,
	getValorEmbarquePorId,
} from "../../services/ModuloGerenciador/ValorEmbarque";
import "./ValorEmbarque.css";

function ValorEmbarque(props) {
	const { profile, tabelaEmpresa, hasRegra } = useProfile();

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [listaClientes, setListaClientes] = useState([]);

	const [listaRotas, setListaRotas] = useState([]);

	const [listaGrupoPrecificacao, setListaGrupoPrecificacao] = useState([]);

	const [valuesSelect, setValuesSelect] = useState([]);

	const [disable, setDisable] = useState(false);

	const [idAtual, setIdAtual] = useState();

	const [loadingSelectRota, setLoadingSelectRota] = useState(false);

	const [openCadastroRota, setOpenCadastroRota] = useState(false);

	const handleCloseCadastroRota = (value) => {
		if (idAtual) {
			setOpenCadastroRota(false);
		} else {
			setLoadingSelectRota(true);
			buscarValorEmbarqueSemLoading();
			setOpenCadastroRota(false);
		}
	};

	const [loadingSelectCliente, setLoadingSelectCliente] = useState(false);

	const [openCadastroCliente, setOpenCadastroCliente] = useState(false);

	const handleCloseCadastroCliente = (value) => {
		if (idAtual) {
			setOpenCadastroCliente(false);
		} else {
			setLoadingSelectCliente(true);
			buscarValorEmbarqueSemLoading();
			setOpenCadastroCliente(false);
		}
	};

	const [loadingSelectGrupoPrecificacao, setLoadingSelectGrupoPrecificacao] =
		useState(false);

	const [openCadastroGrupoPrecificacao, setOpenCadastroGrupoPrecificacao] =
		useState(false);

	const handleCloseCadastroGrupoPrecificacao = (value) => {
		if (idAtual) {
			setOpenCadastroGrupoPrecificacao(false);
		} else {
			setLoadingSelectGrupoPrecificacao(true);
			buscarValorEmbarqueSemLoading();
			setOpenCadastroGrupoPrecificacao(false);
		}
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarValorEmbarqueSemLoading = async () => {
		await getValorEmbarqueDependencias(profile?.token)
			.then((result) => {
				setListaClientes(result.data.clientes);
				setListaRotas(result.data.rotas);
				setListaGrupoPrecificacao(result.data.gruposPrecificacao);
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectGrupoPrecificacao(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const cadastrar = async () => {
		if (
			values.eixos !== "" &&
			validator.eixos === "true" &&
			values.km !== "" &&
			validator.km === "true" &&
			values.valorEixo !== "" &&
			validator.valorEixo === "true" &&
			values.adicionalCargaDescarga !== "" &&
			validator.adicionalCargaDescarga === "true" &&
			values.motorista !== "" &&
			validator.motorista === "true" &&
			values.empresa !== "" &&
			validator.empresa === "true" &&
			values.icms !== "" &&
			validator.icms === "true" &&
			values.descarga !== "" &&
			validator.descarga === "true" &&
			values.pedagio !== "" &&
			validator.pedagio === "true" &&
			values.freteFiscal !== "" &&
			validator.freteFiscal === "true" &&
			values.rotaId !== "" &&
			validator.rotaId === "true" &&
			values.clienteId !== "" &&
			validator.clienteId === "true" &&
			values.grupoPrecificacaoId !== "" &&
			validator.grupoPrecificacaoId === "true"
		) {
			setLoading(true);
			await cadastraValorEmbarque(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarValorEmbarque();
						setDadosRequestControllerRedux("Fechar Modal Embalagem");
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		if (
			values.eixos !== "" &&
			validator.eixos === "true" &&
			values.km !== "" &&
			validator.km === "true" &&
			values.valorEixo !== "" &&
			validator.valorEixo === "true" &&
			values.adicionalCargaDescarga !== "" &&
			validator.adicionalCargaDescarga === "true" &&
			values.motorista !== "" &&
			validator.motorista === "true" &&
			values.empresa !== "" &&
			validator.empresa === "true" &&
			values.icms !== "" &&
			validator.icms === "true" &&
			values.descarga !== "" &&
			validator.descarga === "true" &&
			values.pedagio !== "" &&
			validator.pedagio === "true" &&
			values.freteFiscal !== "" &&
			validator.freteFiscal === "true" &&
			values.rotaId !== "" &&
			validator.rotaId === "true" &&
			values.clienteId !== "" &&
			validator.clienteId === "true" &&
			values.grupoPrecificacaoId !== "" &&
			validator.grupoPrecificacaoId === "true"
		) {
			setLoading(true);
			await editaValorEmbarquePorId(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarValorEmbarque();
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setTelaCadastro(false);
						setEditando(false);
						setValues({});
						setValuesSelect({});
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
						setLoading(false);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
						setOpenToastErro(true);
						setLoading(false);
					}
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const buscarValorEmbarque = async () => {
		setLoading(true);
		buscarValorEmbarqueDependencias();
		await getValorEmbarque(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarValorEmbarqueDependencias = async () => {
		await getValorEmbarqueDependencias(profile?.token)
			.then((result) => {
				setListaClientes(result.data.clientes);
				setListaRotas(result.data.rotas);
				setListaGrupoPrecificacao(result.data.gruposPrecificacao);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarValorEmbarquePorId = async () => {
		setLoading(true);
		await getValorEmbarquePorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result.data);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarValorEmbarquePorId = async () => {
		setLoading(true);
		await deleteValorEmbarquePorId(
			tabelaRedux.colunaSelecionada,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarValorEmbarque();
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Valor Viagem";
		if (telaCadastro) return "Cadastro de Valor Viagem";
		return "Precificação";
	}, [editando, telaCadastro]);

	useEffect(() => {
		setValidator((current) => ({ ...current, eixos: "false" }));
		setValidator((current) => ({ ...current, km: "false" }));
		setValidator((current) => ({ ...current, valorEixo: "false" }));
		setValidator((current) => ({
			...current,
			adicionalCargaDescarga: "false",
		}));
		setValidator((current) => ({ ...current, motorista: "false" }));
		setValidator((current) => ({ ...current, empresa: "false" }));
		setValidator((current) => ({ ...current, icms: "false" }));
		setValidator((current) => ({ ...current, descarga: "false" }));
		setValidator((current) => ({ ...current, pedagio: "false" }));
		setValidator((current) => ({ ...current, freteFiscal: "false" }));
		setValidator((current) => ({ ...current, rotaId: "false" }));
		setValidator((current) => ({ ...current, clienteId: "false" }));
		setValidator((current) => ({ ...current, grupoPrecificacaoId: "false" }));
	}, [telaCadastro]);

	useEffect(() => {
		if (editando && profile?.token) {
			buscarValorEmbarquePorId();
		}
	}, [editando, profile?.token]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Precificação"));
			buscarValorEmbarque();
		}
	}, [profile?.token]);

	const separarPorTipo = (dados) => {
		return dados.reduce((acc, item) => {
			if (!acc[item.grupoPrecificacao.nome]) {
				acc[item.grupoPrecificacao.nome] = [];
			}
			acc[item.grupoPrecificacao.nome].push(item);
			return acc;
		}, {});
	};

	const [dadosPorTipo, setDadosPorTipo] = useState({});

	useEffect(() => {
		if (dadosTabela.length > 0) {
			setDadosPorTipo(separarPorTipo(dadosTabela));
			setLoading(false);
		} else {
			setLoading(false);
		}
	}, [dadosTabela]);

	const preencherDadosEditando = async (result) => {
		const grupoPrecificacaoSelecionado = listaGrupoPrecificacao.find(
			(option) => option.nome === result.grupoPrecificacao.nome
		);
		if (grupoPrecificacaoSelecionado) {
			setValuesSelect((current) => ({
				...current,
				grupoPrecificacaoId: {
					value: grupoPrecificacaoSelecionado.nome,
					label: grupoPrecificacaoSelecionado.nome,
					id: grupoPrecificacaoSelecionado.idPrecificacao,
				},
			}));
			setValues((current) => ({
				...current,
				grupoPrecificacaoId: grupoPrecificacaoSelecionado.idPrecificacao,
			}));
		}
		const rotaSelecionado = listaRotas.find(
			(option) => option.nome === result.rota.nome
		);
		if (rotaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				rotaId: {
					value: rotaSelecionado.nome,
					label: rotaSelecionado.nome,
					id: rotaSelecionado.idRota,
				},
			}));
			setValues((current) => ({ ...current, rotaId: rotaSelecionado.idRota }));
		}
		const clienteSelecionado = listaClientes.find(
			(option) => option.nomeFantasia === result.cliente.nomeFantasia
		);
		if (clienteSelecionado) {
			setValuesSelect((current) => ({
				...current,
				clienteId: {
					value: clienteSelecionado.nomeFantasia,
					label: clienteSelecionado.nomeFantasia,
					id: clienteSelecionado.idCliente,
				},
			}));
			setValues((current) => ({
				...current,
				clienteId: clienteSelecionado.idCliente,
			}));
		}
	};

	useEffect(() => {
		if (dadosRequestControllerRedux === "Fechar Modal Cliente") {
			handleCloseCadastroCliente();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
		if (dadosRequestControllerRedux === "Fechar Modal Rota") {
			handleCloseCadastroRota();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
	}, [dadosRequestControllerRedux]);

	const clearGrupoPrecificacao = () => {
		setValuesSelect((current) => ({ ...current, grupoPrecificacaoId: "" }));
		setValues((current) => ({ ...current, grupoPrecificacaoId: null }));
		setValidator((current) => ({ ...current, grupoPrecificacaoId: "false" }));
	};

	const clearRota = () => {
		setValuesSelect((current) => ({ ...current, rotaId: "" }));
		setValues((current) => ({ ...current, rotaId: null }));
		setValidator((current) => ({ ...current, rotaId: "false" }));
	};

	const clearCliente = () => {
		setValuesSelect((current) => ({ ...current, clienteId: "" }));
		setValues((current) => ({ ...current, clienteId: null }));
		setValidator((current) => ({ ...current, clienteId: "false" }));
	};

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="ValorEmbarqueScreenContainer">
						<div className="content-container">
							{Object.keys(dadosPorTipo).length === 1
								? Object.keys(dadosPorTipo).map((tipo, index) => (
										<div key={index}>
											<h3>{tipo}</h3>
											<TabelaV2
												setTelaCadastro={setTelaCadastro}
												setEditando={setEditando}
												classeSelecionado="idValorEmbarque"
												nomeClasse1="outer-wrapper-v2"
												nomeClasse2="table-v2-center"
												colunas={tabelaEmpresa.ValorEmbarque}
												dados={dadosPorTipo[tipo]}
												isLoading={loading}
											/>
										</div>
								  ))
								: Object.keys(dadosPorTipo).map((tipo, index, array) => {
										if (index % 2 === 0) {
											return (
												<div key={index} className="flexContainerValor">
													<div>
														<h3>{tipo}</h3>
														<TabelaV2
															setTelaCadastro={setTelaCadastro}
															setEditando={setEditando}
															classeSelecionado="idValorEmbarque"
															nomeClasse1="outer-wrapper-v2"
															nomeClasse2="table-v2-center"
															colunas={tabelaEmpresa.ValorEmbarque}
															dados={dadosPorTipo[tipo]}
															isLoading={loading}
														/>
													</div>

													{array[index + 1] && (
														<div>
															<h3>{array[index + 1]}</h3>
															<TabelaV2
																setTelaCadastro={setTelaCadastro}
																setEditando={setEditando}
																classeSelecionado="idValorEmbarque"
																nomeClasse1="outer-wrapper-v2"
																nomeClasse2="table-v2-center"
																colunas={tabelaEmpresa.ValorEmbarque}
																dados={dadosPorTipo[array[index + 1]]}
																isLoading={loading}
															/>
														</div>
													)}
												</div>
											);
										}
										return null;
								  })}
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="ValorEmbarqueCadastroScreenContainer">
						<div className="content-container">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Valor Viagem /"}</p>
										{editando ? (
											<p className="indicador-emb">
												{"Detalhes de Valor Viagem"}
											</p>
										) : (
											<p className="indicador-emb">
												{"Cadastro de Valor Viagem"}
											</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Eixos:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															eixos: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															eixos: "true",
														}));
													}}
													value={values.eixos}
													disabled={props.desabilitar}
													placeholder="Ex: 1"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													KM:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															km: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															km: "true",
														}));
													}}
													value={values.km}
													disabled={props.desabilitar}
													placeholder="Ex: 50"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Valor Eixo:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															valorEixo: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															valorEixo: "true",
														}));
													}}
													value={values.valorEixo}
													disabled={props.desabilitar}
													placeholder="Ex: 100"
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Adicional Descarga:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															adicionalCargaDescarga: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															adicionalCargaDescarga: "true",
														}));
													}}
													value={values.adicionalCargaDescarga}
													disabled={props.desabilitar}
													placeholder="Ex: 100"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Motorista:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															motorista: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															motorista: "true",
														}));
													}}
													value={values.motorista}
													disabled={props.desabilitar}
													placeholder="Ex: João"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Empresa:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															empresa: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															empresa: "true",
														}));
													}}
													value={values.empresa}
													disabled={props.desabilitar}
													placeholder="Ex: Cassava"
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													ICMS:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															icms: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															icms: "true",
														}));
													}}
													value={values.icms}
													disabled={props.desabilitar}
													placeholder="Ex: 100"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Descarga:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															descarga: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															descarga: "true",
														}));
													}}
													value={values.descarga}
													disabled={props.desabilitar}
													placeholder="Ex: 0"
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Pedágio:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															pedagio: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															pedagio: "true",
														}));
													}}
													value={values.pedagio}
													disabled={props.desabilitar}
													placeholder="Ex: 0"
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										{loadingSelectGrupoPrecificacao ? (
											<LoadingBar />
										) : (
											<div className="coluna-emb">
												<div>
													<p className="input-label-emb" htmlFor="descricao">
														Grupo Precificação:
													</p>
													<SelectEmbarqueV2
														classeCss={230}
														onChange={(e) => {
															setValuesSelect((current) => ({
																...current,
																grupoPrecificacaoId: e,
															}));
															setValues((current) => ({
																...current,
																grupoPrecificacaoId: e.id,
															}));
															setValidator((current) => ({
																...current,
																grupoPrecificacaoId: "true",
															}));
														}}
														onClick={(e) => {
															e.stopPropagation();
															setDisable(true);
															setOpenCadastroGrupoPrecificacao(true);
														}}
														clearSelection={clearGrupoPrecificacao}
														onInfoIconClick={setIdAtual}
														id="idPrecificacao"
														grande={true}
														value={valuesSelect.grupoPrecificacaoId}
														titulo="Grupo Precificação"
														dadosSelect={listaGrupoPrecificacao}
														referenciaId="nome"
														referenciaItem="nome"
													/>
												</div>
												<NewIcon
													onClick={(e) => {
														setOpenCadastroGrupoPrecificacao(true);
														setIdAtual(null);
														setDisable(false);
													}}
												/>
											</div>
										)}
										<div className="coluna-emb">
											{loadingSelectRota ? (
												<LoadingBar />
											) : (
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Rota:
														</p>
														<SelectEmbarqueV2
															classeCss={230}
															onChange={(e) => {
																setValuesSelect((current) => ({
																	...current,
																	rotaId: e,
																}));
																setValues((current) => ({
																	...current,
																	rotaId: e.id,
																}));
																setValidator((current) => ({
																	...current,
																	rotaId: "true",
																}));
															}}
															onClick={(e) => {
																e.stopPropagation();
																setDisable(true);
																setOpenCadastroRota(true);
															}}
															clearSelection={clearRota}
															onInfoIconClick={setIdAtual}
															id="idRota"
															grande={true}
															value={valuesSelect.rotaId}
															titulo="Rota"
															dadosSelect={listaRotas}
															referenciaId="nome"
															referenciaItem="nome"
														/>
													</div>
													<NewIcon
														onClick={(e) => {
															setOpenCadastroRota(true);
															setIdAtual(null);
															setDisable(false);
														}}
													/>
												</div>
											)}
										</div>
										<div className="coluna-emb">
											{loadingSelectCliente ? (
												<LoadingBar />
											) : (
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Cliente:
														</p>
														<SelectEmbarqueV2
															classeCss={230}
															onChange={(e) => {
																setValuesSelect((current) => ({
																	...current,
																	clienteId: e,
																}));
																setValues((current) => ({
																	...current,
																	clienteId: e.id,
																}));
																setValidator((current) => ({
																	...current,
																	clienteId: "true",
																}));
															}}
															onClick={(e) => {
																e.stopPropagation();
																setDisable(true);
																setOpenCadastroCliente(true);
															}}
															clearSelection={clearCliente}
															onInfoIconClick={setIdAtual}
															id="idCliente"
															grande={true}
															value={valuesSelect.clienteId}
															titulo="Grupo Cliente"
															dadosSelect={listaClientes}
															referenciaId="nomeFantasia"
															referenciaItem="nomeFantasia"
														/>
													</div>
													<NewIcon
														onClick={(e) => {
															setOpenCadastroCliente(true);
															setIdAtual(null);
															setDisable(false);
														}}
													/>
												</div>
											)}
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div className="principal">
												<p className="input-label-emb" htmlFor="descricao">
													Frete Fiscal:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "270px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															freteFiscal: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															freteFiscal: "true",
														}));
													}}
													value={values.freteFiscal}
													disabled={props.desabilitar}
													placeholder="Ex: 100"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.eixos !== "" &&
														validator.eixos === "true" &&
														values.km !== "" &&
														validator.km === "true" &&
														values.valorEixo !== "" &&
														validator.valorEixo === "true" &&
														values.adicionalCargaDescarga !== "" &&
														validator.adicionalCargaDescarga === "true" &&
														values.motorista !== "" &&
														validator.motorista === "true" &&
														values.empresa !== "" &&
														validator.empresa === "true" &&
														values.icms !== "" &&
														validator.icms === "true" &&
														values.descarga !== "" &&
														validator.descarga === "true" &&
														values.pedagio !== "" &&
														validator.pedagio === "true" &&
														values.freteFiscal !== "" &&
														validator.freteFiscal === "true" &&
														values.rotaId !== "" &&
														validator.rotaId === "true" &&
														values.clienteId !== "" &&
														validator.clienteId === "true" &&
														values.grupoPrecificacaoId !== "" &&
														validator.grupoPrecificacaoId === "true"
													) {
														cadastrar();
														setValues({});
														setValuesSelect({});
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.eixos !== "" &&
														validator.eixos === "true" &&
														values.km !== "" &&
														validator.km === "true" &&
														values.valorEixo !== "" &&
														validator.valorEixo === "true" &&
														values.adicionalCargaDescarga !== "" &&
														validator.adicionalCargaDescarga === "true" &&
														values.motorista !== "" &&
														validator.motorista === "true" &&
														values.empresa !== "" &&
														validator.empresa === "true" &&
														values.icms !== "" &&
														validator.icms === "true" &&
														values.descarga !== "" &&
														validator.descarga === "true" &&
														values.pedagio !== "" &&
														validator.pedagio === "true" &&
														values.freteFiscal !== "" &&
														validator.freteFiscal === "true" &&
														values.rotaId !== "" &&
														validator.rotaId === "true" &&
														values.clienteId !== "" &&
														validator.clienteId === "true" &&
														values.grupoPrecificacaoId !== "" &&
														validator.grupoPrecificacaoId === "true"
													) {
														cadastrar();
														setValues({});
														setValuesSelect({});
														setTelaCadastro(false);
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesSelect({});
										setTelaCadastro(false);
										setEditando(false);
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarValorEmbarquePorId}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={handleCloseUsuario}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroRota="sim"
				open={openCadastroRota}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroRota}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroCliente="sim"
				open={openCadastroCliente}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroCliente}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroGrupoPrecificacao="sim"
				open={openCadastroGrupoPrecificacao}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroGrupoPrecificacao}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default ValorEmbarque;
